import script from "./ProjectCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCalendar.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCalendar.vue?vue&type=style&index=0&id=19b32a70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b32a70"]])

export default __exports__